import React from "react";
import { useSelector } from "react-redux";
import { networkTypeSelector } from "store/userSliceHelpers";
import "../index.css";
import "./issuer-layout.css";
import IssuerNav from "components/navbar/IssuerNav";
import { useAppConfig } from "features/config/useAppConfig";
import { apiErrorMessage } from "utils/errors/parseApiError";

interface Props {
  children: React.ReactNode;
}

function IssuerLayout({ children }: Props) {
  const networkType = useSelector(networkTypeSelector);

  // Server-owned config (the RPC endpoint) is loaded here, once, because it is
  // what @gardio/contracts and @gardio/extensions run on — every chain read and
  // every wallet connection below this point throws without it. Chrome still
  // renders; only the content waits.
  const configQuery = useAppConfig();
  const isConfigLoading = configQuery.isEnabled && configQuery.isPending;

  return (
    <div className="gp-layout gp-layout--issuer">
      <div className="gp-layout-inner">
        <IssuerNav networkType={networkType} />
        <section className="gp-layout-content">
          {isConfigLoading ? (
            <div className="issuer-layout__config-state">
              Loading configuration…
            </div>
          ) : configQuery.isError ? (
            <div className="issuer-layout__config-state">
              {apiErrorMessage(
                configQuery.error,
                "Could not load app configuration. Reload the page to try again.",
              )}
            </div>
          ) : (
            children
          )}
        </section>
      </div>
      <div className="issuer-page__footer">© 2026 gardioPay · Treasury</div>
    </div>
  );
}

export default IssuerLayout;
